module.exports = __webpack_public_path__ + "825735062e7815ecdbf574bb3ac51814.ttf";